<template>
  <div
    class="cursor-pointer like-btn"
    :class="{
      '!cursor-not-allowed': disabled,
      'active-icon': like,
    }"
    @click.stop.prevent="onClick"
  >
    <a-popover>
      <template #content>
        <span class="text-font-1 text">{{
          props.disabled
            ? $t('shang-jia-hou-ji-ke-cao-zuo')
            : like
            ? $t('qu-xiao-shou-cang')
            : $t('shou-cang')
        }}</span>
      </template>
      <slot :like="like">
        <iconpark-icon
          :class="iconClass"
          :size="size || 14"
          class="text-white star"
          :name="like ? 'like-outlined' : 'unlike-outlined'"
        ></iconpark-icon>
      </slot>
    </a-popover>
  </div>
</template>

<script lang="ts" setup>
import { h } from 'vue'
import { getTagIDs } from '../template'
import { cancelCollect, addCollect } from '@/api'
import { COLLECTION_SOURCE } from '~/utils/constant'
import type { BrandItem, Template } from '~/api/interface'
import type { IMediaCard } from '~/components/listCard'
import { COLLECTION_MAP } from '~/constants'
import type { Character } from '~/api/interface/character'
interface Params {
  is_user_upload?: boolean // 是否是用户上传的收藏
  model_id: number // 对应内容id，如作品id，成片id,素材id，片头片尾id
  model_type?: COLLECTION_MAP // 收藏类型 COLLECTION_MAP
  source?: COLLECTION_SOURCE
  resource_type?: RESOURCE_TYPE // 资源类型 TARGET_FROM
  media_type?: FILE_TYPE_MAP // 素材类型 FILE_TYPE_MAP
  [key: string | number]: any
}

const { $t } = useNuxtApp()
const props = defineProps<{
  modelValue?: boolean
  disabled?: boolean
  params: Params
  size?: number
  data?: BrandItem | Template | IMediaCard | Character
  iconClass?: string
  onReload?: (v: any) => void
  onChange?: (v: boolean) => void
}>()
const emit = defineEmits(['update:modelValue', 'change', 'reload'])

const userInfo = useUserInfo()

const like = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue', v)
    emit('change', v)
  },
})

const onCancel = inject('onCancel', () => {}) as Function

/**
 * source只给埋点使用
 */
const source = injectResourceLocation()

let target: TARGET_FROM | undefined

/**
 * 根据后端接口定义，这里有model_type，source，resource_type三个
 * 然后根据这三个字段匹配出埋点需要的target和source
 */

if (props.params.model_type !== undefined) {
  target = getTargetForEventTracking(
    props.params.model_type,
    props.params.resource_type
  )
}

const trackParams: any = {
  target,
  source: source?.source,
  org_id: userInfo.value?.organization_id,
}

const onClick = async () => {
  if (props.disabled) {
    return
  }
  const oldValue = like.value
  like.value = !like.value

  try {
    if (
      [
        COLLECTION_MAP.PIECES,
        COLLECTION_MAP.PIECES_TEMPLATE,
        COLLECTION_MAP.OPUS,
      ].includes(props.params.model_type as COLLECTION_MAP)
    ) {
      const data = props.data as Template
      trackParams.template_id = data.id
      trackParams.template_title = data.title || data.name
    }

    if (
      [COLLECTION_MAP.PIECES, COLLECTION_MAP.PIECES_TEMPLATE].includes(
        props.params.model_type as COLLECTION_MAP
      )
    ) {
      const data = props.data as Template
      trackParams.tags = getTagIDs(data.tag_ids).map((item) => item.tag_name)
    }

    let eventName = oldValue
      ? TRACK_EVENT.YOUYAN_PLATFORM_CANCEL_COLLECT
      : TRACK_EVENT.YOUYAN_PLATFORM_COLLECT

    if (props.params.model_type === COLLECTION_MAP.SOURCE) {
      if (props.params.resource_type === RESOURCE_TYPE.PERSON) {
        const data = props.data as Character
        trackParams.look_name = data?.look_name
        trackParams.name = data?.name
        trackParams.tags = data?.tags
        eventName = oldValue
          ? TRACK_EVENT.YOUYAN_PLATFORM_CANCEL_COLLECT_CHARACTER
          : TRACK_EVENT.YOUYAN_PLATFORM_COLLECT_CHARACTER
      }
    }

    let res
    if (oldValue) {
      trackEvent(eventName, trackParams)
      const { model_id, ...rest } = props.params
      res = await cancelCollect({
        model_ids: [model_id],
        ...rest,
      })
    } else {
      trackEvent(eventName, trackParams)
      res = await addCollect(props.params)
    }
    if (!res.code) {
      const text = !oldValue
        ? h('a', { class: 'ml-[10px]', onClick: goLink }, $t('dian-ji-cha-kan'))
        : ''
      message.success({
        content: h('div', [
          !oldValue ? $t('yi-shou-cang') : $t('yi-qu-xiao-shou-cang'),
          text,
        ]),
        duration: 2,
      })
      emit('reload', props.params.model_id)
    } else {
      like.value = oldValue
    }
  } catch (error) {
    console.error(error)

    like.value = oldValue
  }
}

const goLink = () => {
  onCancel?.()
  const open = useTemplateVisible()
  open.value = false
  navigateTo(
    `/home/collection?model_type=${props.params.model_type}&resource_type=${
      props.params.resource_type !== undefined
        ? props.params.resource_type
        : RESOURCE_TYPE.STUDIO
    }`
  )
}
</script>

<style lang="scss">
.dark {
  .like-btn:hover {
    color: var(--purple-6) !important;
  }
  .active-icon.like-btn {
    color: var(--purple-6) !important;
  }
}
</style>
<style lang="scss" scoped>
.like-btn {
  @apply flex-center w-[28px] h-[28px] rounded-[50%] text-primary text-center text-[14px];
  z-index: 1;
  // opacity: 0.6;
  background: $action-icon-bg;
  // box-shadow: 0px 2px 6px 0px rgba(86, 80, 220, 0.1);
  &:not(.active-icon) {
    color: var(--text-primary-reverse);
  }

  &:hover {
    background: $action-icon-bg-hover;
  }
}
</style>
